/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Confirm_Truth_ErrorInputs */

const en_register_onboarding_confirm_truth_error = /** @type {(inputs: Register_Onboarding_Confirm_Truth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm the accuracy of your information to submit your application.`)
};

const de_register_onboarding_confirm_truth_error = /** @type {(inputs: Register_Onboarding_Confirm_Truth_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte bestätige die Richtigkeit deiner Angaben, um deine Bewerbung einzureichen.`)
};

/**
* | output |
* | --- |
* | "Please confirm the accuracy of your information to submit your application." |
*
* @param {Register_Onboarding_Confirm_Truth_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_confirm_truth_error = /** @type {((inputs?: Register_Onboarding_Confirm_Truth_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Confirm_Truth_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_confirm_truth_error(inputs)
	return en_register_onboarding_confirm_truth_error(inputs)
});